/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterSalaryDto } from '../../models/center-salary-dto';
import { CreateCenterSalaryDto } from '../../models/create-center-salary-dto';

export interface CenterSalaryControllerUpdate$Params {
  id: string;
      body: CreateCenterSalaryDto
}

export function centerSalaryControllerUpdate(http: HttpClient, rootUrl: string, params: CenterSalaryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterSalaryDto>> {
  const rb = new RequestBuilder(rootUrl, centerSalaryControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterSalaryDto>;
    })
  );
}

centerSalaryControllerUpdate.PATH = '/api/center-salary/{id}';
